import { productImage } from "@/mocks/landingData";
import { Link } from "react-router-dom";

export default function Footer() {
  const handleCtaClick = () => {
    if (typeof window !== "undefined" && (window as Record<string, unknown>).dataLayer) {
      ((window as Record<string, unknown>).dataLayer as Array<Record<string, unknown>>).push({
        event: "cta_click",
        cta_text: "CLICK HERE TO CHECK AVAILABILITY",
      });
    }
  };

  return (
    <footer id="cta-final" className="bg-foreground-800 text-white py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 mb-16">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Take The Next Step
              <br />
              Toward Better Joint
              <br />
              Mobility
            </h2>
            <p className="text-white/70 text-xl md:text-2xl leading-relaxed mb-8 max-w-lg">
              Review ingredients, pricing, guarantee information and current
              availability directly from the official source.
            </p>
            <a
              href="https://fbb3fpv745sq39ufzaqeh7ts3m.hop.clickbank.net/?&amp;traffic_source=googleads&amp;traffic_type=ppc&amp;campaign=jointgen50plus-1&amp;creative=landingpage&amp;adgroup=articulacoes50plus-1&amp;ad=review_1&amp;extclid=googleleads"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCtaClick}
              className="inline-flex items-center justify-center px-10 py-5 rounded-full bg-primary-500 text-foreground-950 font-bold text-xl hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer uppercase tracking-wide btn-hover-lift animate-cta-pulse"
            >
              CLICK HERE TO CHECK AVAILABILITY
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
              <img
                src={productImage}
                alt="Joint Genesis Supplement Bottle"
                className="w-full max-w-xs h-auto object-contain hover-img-zoom"
                width={400}
                height={600}
              />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-base text-white/50">
            <div className="flex items-center gap-4">
              <span className="font-heading text-lg font-semibold text-white">
                JOINT GENESIS
              </span>
              <span>Editorial</span>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="hover:text-white/80 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white/80 transition-colors">
                Terms of Use
              </Link>
            </div>
            <div>
              <span>&copy; 2026 All rights reserved.</span>
            </div>
          </div>
          <p className="text-center text-base text-white/40 mt-6 max-w-3xl mx-auto">
            *These statements have not been evaluated by the FDA. This product is
            not intended to diagnose, treat, cure, or prevent any disease.
            Individual results may vary. Always consult your healthcare provider
            before starting any new supplement.
          </p>
        </div>
      </div>
    </footer>
  );
}